export default [
  {
    path: '/profile',
    name: 'userProfile',
    component: () => import('./pages/AccountSetting.vue'),
    meta: {
      layout: 'vertical',
      requiresAuth: true,
      pageTitle: 'Meu perfil',
      breadcrumb: [
        {
          text: 'Perfil',
          active: true,
        },
      ],
    },
  },
]
